import { normalizeLocale } from '@/common/util/i18n'
import tokens from '@/configuration/sources/Tokens.yml'

/**
 * Applies a casting defined for the given value
 */
export const castValue = (locator, value, attribute, casting = null) => {
  if (!casting) return value

  switch (casting) {
    case 'int':
    case 'integer':
      return parseInt(value, 10)
    case 'string':
      return `${value}`
    case 'bool':
    case 'boolean':
      // Casting only if number
      if (typeof value == 'number') value = `${value}`
      if (typeof value !== 'string') return value
      if (value.toLowerCase() == 'true') return true
      if (value.toLowerCase() == 'false') return false
      return `${value}` === '1'
    case 'csv':
      return value.split(',')
    case 'hasAttribute':
      return value || value === '' ? true : false
    case 'hasNoAttribute':
      return value || value === '' ? false : true
    case 'language':
      return normalizeLocale(value)
    case 'popin':
      const isPopin = castValue(locator, value, attribute, 'hasAttribute')
      return isPopin ? 'popin' : 'embedded'
    case 'formToken':
      const currentFormToken = locator.$store.state.formToken
      if (currentFormToken !== tokens.noToken) return currentFormToken
      const token = locator.tokenReader.verifyToken(value)
      locator.tokenReader.setWhiteLabel(token)
      return token
    case 'gridLayout':
      const isGrid = castValue(locator, value, attribute, 'hasAttribute')
      const currentLayout = locator.$store.state.smartForm.layout
      return isGrid ? 'grid' : currentLayout
    case 'gridCols':
      const parsedNumber = castValue(locator, value, attribute, 'int')
      if (!isNaN(parsedNumber)) return parsedNumber
      if (value === 'max') return value
      console.warn(
        `The provided value for ${attribute} is not valid it should be an Integer or 'max'. The value has been ignored`
      )
      return locator.$store.state.smartForm?.otherPaymentMethodsLayout?.grid
        ?.columns
    case 'nativeLook':
      const paymentMethods = value.split(',').filter(Boolean) // '' -> []

      return {
        enabled: {
          preferredMethods: true,
          otherMethods: true
        },
        paymentMethods
      }
  }

  return value
}
